import React from 'react'
import {Overview} from '../Pages/Overview/OverviewPage'

function OverView() {
  return (
    <>
        <Overview />
    </>
  )
}

export default OverView
